import { BehaviorSubject } from 'rxjs';
import { FormGroup } from '@angular/forms'; import { Injectable } from '@angular/core';
import { environment } from '../../../environments/environment';
import { HttpClient, HttpHeaders, HttpResponse, HttpErrorResponse, HttpParams } from '@angular/common/http';
import { ExportParams } from '../model/filterparams';
import { CaseStepInfo } from '../model/CaseStepInfo';


@Injectable({
  providedIn: 'root'
})
export class EympService {
  [x: string]: any;
  constructor(private _http: HttpClient) { }
  getDashboardCount(startDate, endDate) {
    let params = new HttpParams();
    params = params.append('startDate', startDate);
    params = params.append('endDate', endDate);


    return this._http.get<any>(environment.ApiUrl + 'EYMPRevFlow/GetEympReverseflowDashboardCount', { params: params });
  }
  getEympReverseflowDetailsWithStatus(status: string,startDate, endDate, mode: string, filterParams: ExportParams) {

    return this._http.post<any>(environment.ApiUrl + 'EYMPRevFlow/GetEympRevflowDetailsbyStatus?status=' + status + '&startDate=' + startDate + '&endDate=' + endDate + '&mode=' + mode, filterParams, {});
  }
  getCaseStepInfo(caseid: string, status: string, startDate, endDate) {
    return this._http.get<CaseStepInfo[]>(environment.ApiUrl + 'EYMPRevFlow/GetCaseStepInfo?caseId=' + caseid + '&status=' + status + '&startDate=' + startDate + '&endDate=' + endDate, {});
  }
  getEympRevflowDetInExcel(status: string, startDate, endDate, mode: string, filterParams: ExportParams) {

    return this._http.post<any>(environment.ApiUrl + 'EYMPRevFlow/GetEympRevflowDetInExcel?status=' + status + '&startDate=' + startDate + '&endDate=' + endDate + '&mode=' + mode, filterParams, {});
  }
}
